import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, es: { translation: es }, fr: { translation: fr } },
    lng: 'es',
    fallbackLng: 'es',
    supportedLngs: ['en', 'es', 'fr'],
    interpolation: { escapeValue: false }
  });

export default i18n;